import { forwardRef, Icon, IconProps } from "@chakra-ui/react";
export default forwardRef<IconProps, "svg">((props, svgRef) => (
  <Icon
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={20}
    fill="none"
    viewBox="0 0 18 20"
    ref={svgRef}
    {...props}
  >
    <path
      fill="currentColor"
      d="M10.696 1.5a1 1 0 011-1c1.745 0 3.246.897 4.281 2.028 1.025 1.118 1.72 2.598 1.72 3.972a1 1 0 01-1 1h-5a1 1 0 01-1-1v-5zm2 1.165V5.5h2.805a4.912 4.912 0 00-.998-1.621c-.517-.564-1.139-.994-1.807-1.214zM3.692 9.3a1 1 0 011-1h11.813a1 1 0 011 1c0 3.662-3.157 6.516-6.906 6.516-3.75 0-6.907-2.854-6.907-6.516zm2.122 1c.49 1.976 2.4 3.516 4.784 3.516 2.386 0 4.295-1.54 4.785-3.516H5.814z"
    />
    <path
      fill="currentColor"
      d="M.225 4.447a1 1 0 011-1H3.2a1 1 0 01.964.736l1.477 5.393a1 1 0 01-1.929.528L2.437 5.447H1.225a1 1 0 01-1-1zM4.347 17.68a1.81 1.81 0 011.801-1.82c.995 0 1.802.815 1.802 1.82a1.81 1.81 0 01-1.802 1.82 1.811 1.811 0 01-1.801-1.82zm8.798 0a1.81 1.81 0 011.801-1.82c.995 0 1.802.815 1.802 1.82a1.81 1.81 0 01-1.802 1.82 1.811 1.811 0 01-1.801-1.82z"
    />
  </Icon>
));
